import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Header section for Inactive Users page
 */
const InactiveUsersHeader = ({ totalCount = 0 }) => {
  return (
    <Box sx={{ marginBottom: "32px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: "#1a1a1a",
            fontSize: "1.75rem",
          }}
        >
          Inactive / Dormant Users
        </Typography>
        <Tooltip
          title={
            <Box sx={{ p: 0.5 }}>
              <Typography variant="body2" sx={{ fontSize: "0.85rem", mb: 0.5 }}>
                Showing users from all countries across organizations you administer (Owner or Approver).
              </Typography>
              <Typography variant="caption" sx={{ fontSize: "0.75rem", fontStyle: "italic" }}>
                Countries are aggregated from all organizations where you are an Org Owner.
              </Typography>
            </Box>
          }
          arrow
          placement="right"
        >
          <IconButton 
            size="small" 
            sx={{ color: "#666", p: 0, display: "flex", alignItems: "center" }}
          >
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "#666",
          fontSize: "0.95rem",
          lineHeight: 1.6,
          marginTop: "8px",
        }}
      >
        Monitor user activity across all organizations you administer
        {totalCount > 0 && ` • Total: ${totalCount} user${totalCount !== 1 ? 's' : ''}`}
      </Typography>
    </Box>
  );
};

export default InactiveUsersHeader;
